import React, { useState, useEffect } from "react";

const Switch = React.forwardRef(({
  switched: propsSwitched,
  callBack,
  disabled,
  className,
  ...rest
}, ref) => {
  const [switched, setSwitched] = useState(propsSwitched);

  useEffect(() => {
    if (propsSwitched !== undefined && propsSwitched !== switched) {
      setSwitched(propsSwitched);
    }
  }, [propsSwitched]);

  useEffect(() => {
    if (switched !== undefined && propsSwitched !== switched) {
      if (callBack) {
        callBack(switched);
      }
    }
  }, [switched]);

  const classes = [
    "ta-switch",
    disabled && "ta-is-disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      ref={ref}
      onClick={() => !disabled && setSwitched(!switched)}
      className={classes}
      data-switched={switched ? "true" : undefined}
      {...rest}
    />
  );
});

export default Switch;
